export const ESIM_JOURNEY_REDIRECT_TARGET_KEY = "esimJourneyRedirectTarget";

export const setEsimJourneyRedirectTarget = (target: string) => {
  sessionStorage.setItem(ESIM_JOURNEY_REDIRECT_TARGET_KEY, target);
};

export const getEsimJourneyRedirectTarget = () =>
  sessionStorage.getItem(ESIM_JOURNEY_REDIRECT_TARGET_KEY);

export const clearEsimJourneyRedirectTarget = () => {
  sessionStorage.removeItem(ESIM_JOURNEY_REDIRECT_TARGET_KEY);
};
